import LegalLayout, { LegalSection } from "@/components/pages/LegalLayout";

const TermsOfUse = () => {
  return (
    <LegalLayout
      title="Terms of Use — OrderHalal.ai"
      effectiveDate="August 1, 2026"
      metaDescription="The terms governing your use of the OrderHalal.ai website, inquiry forms, and demo booking."
    >
      <LegalSection heading="1. Agreement to Terms">
        <p>
          By accessing or using this website, submitting an inquiry, or booking a demo with
          OrderHalal.ai ("we," "us," "our"), a Texas-based sole proprietorship, you agree to these
          Terms of Use. If you do not agree, please discontinue use of this website.
        </p>
      </LegalSection>

      <LegalSection heading="2. Purpose of This Site">
        <p>
          This website provides information about our AI voice agent services and allows visitors to
          request more information or schedule a demo. Submitting an inquiry does not create a
          contractual relationship; a separate service agreement governs any paid engagement.
        </p>
      </LegalSection>

      <LegalSection heading="3. No Guarantee of Availability">
        <p>
          We make reasonable efforts to keep this website and our demo booking and inquiry systems
          available and accurate, but we do not guarantee uninterrupted availability and are not
          liable for temporary outages or errors.
        </p>
      </LegalSection>

      <LegalSection heading="4. Intellectual Property">
        <p>
          All content on this website, including text, branding, and design, is the property of
          OrderHalal.ai unless otherwise noted, and may not be copied or reused without permission.
        </p>
      </LegalSection>

      <LegalSection heading="5. Limitation of Liability">
        <p>
          To the fullest extent permitted by law, OrderHalal.ai is not liable for any indirect,
          incidental, or consequential damages arising from your use of this website.
        </p>
      </LegalSection>

      <LegalSection heading="6. Changes to These Terms">
        <p>
          We may update these Terms of Use at any time. Continued use of this website after changes
          are posted constitutes acceptance of the updated terms.
        </p>
      </LegalSection>

      <LegalSection heading="7. Governing Law">
        <p>These Terms are governed by the laws of the State of Texas.</p>
      </LegalSection>

      <LegalSection heading="8. Contact Us">
        <p>
          OrderHalal.ai
          <br />
          Richardson, Texas
          <br />
          <a href="mailto:contact@orderhalal.ai" className="text-terra hover:underline">
            contact@orderhalal.ai
          </a>
        </p>
      </LegalSection>

      <hr className="border-line" />
      <p className="text-sm text-sand/60 italic leading-relaxed">
        This document is a general terms-of-use notice for a small, pre-formation business website
        and has not been reviewed by an attorney.
      </p>
    </LegalLayout>
  );
};

export default TermsOfUse;
